/* eslint-disable no-console */
const MiniSelectEditor = {
  props: {
    value: {},
    width: { type: [String, Number] },
    items: { type: Array },
    required: { type: Boolean, default: false },
    itemValue: { type: String, default: 'code' }, // 下拉项目值属性，如果设置了indexValue为true，则忽略此属性
    itemText: { type: String, default: 'name' }, // 下拉项目显示属性
    indexValue: { type: Boolean, default: false } // 是否使用索引作为值
  },
  model: { event: 'change' },
  computed: {
    styles () {
      return this.width ? { width: this.width + 'px' } : {}
    }
  },
  methods: {
    onChange (e) {
      this.$emit('change', e.target.value);
    },
    genOptions () {
      let ret = [];
      if (this.items && this.items.length) {
        if (!this.required) ret.push(this.$createElement('option', { attrs: { value: 0 } }, ''));
        this.items.forEach((item, idx) => {
          let snf = typeof item == 'string' || typeof item == 'number';
          ret.push(this.$createElement('option', { attrs: { value: snf ? item : this.indexValue ? idx : item[this.itemValue] } }, snf ? item : item[this.itemText]))
        });
      }
      return ret;
    }
  },
  render (h) {
    return h('select', {
      domProps: { value: this.value },
      class: 'r-mini-editor',
      style: this.styles,
      options: this.genOptions(),
      on: {
        change: this.onChange
      }
    }, this.genOptions())
  }
}

export default {
  install: function (Vue) {
    Vue.component('mini-select-editor', MiniSelectEditor)
  }
}